import { useTranslation } from 'react-i18next';

export default function OverlaySelector({ overlays, selectedOverlayId, onChange }) {
  const { t } = useTranslation();

  return (
    <div className="ardosz-control-group">
      <label htmlFor="overlay-select">{t('overlay')}</label>
      <select
        id="overlay-select"
        value={selectedOverlayId}
        onChange={(event) => onChange(event.target.value)}
      >
        {overlays.map((overlay) => (
          <option key={overlay.id} value={overlay.id}>
            {t(overlay.labelKey)}
          </option>
        ))}
      </select>
    </div>
  );
}
